export default [
  {
    path: '',
    name: 'customer list',
    component: () => import('@/views/app/customer/page-list.vue'),
    meta: { title: 'Daftar Customer' },
  },
]
